import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  ANALYTICS_EVENTS,
  DataRow,
  Drawer,
  useEvent,
  useGlobalCopyStore,
  useRecurringTransactionsStore,
} from '../../../common'
import { type RepeatingTransaction, Frequency } from '../../../core'

import { getFrequencyLabel } from '../../../core/utils/RecurringTransactionsUtil'

import { PaymentSchedule } from '../PaymentSchedule'

interface FrequencyActionProps {
  repeatingTransaction: RepeatingTransaction
}

export const PaymentScheduleAction = observer(({ repeatingTransaction }: FrequencyActionProps) => {
  const { recurring: copy } = useGlobalCopyStore()
  const { updateRepeatingTransaction } = useRecurringTransactionsStore()

  const { onEvent } = useEvent()
  const [isOpen, setIsOpen] = React.useState(false)
  const [frequency, setFrequency] = React.useState<Frequency>(repeatingTransaction.recurrence_type)
  const [firstDay, setFirstDay] = React.useState(repeatingTransaction.recurrence_day)
  const [secondDay, setSecondDay] = React.useState(repeatingTransaction.second_recurrence_day)

  const handleSave = async () => {
    await updateRepeatingTransaction({
      ...repeatingTransaction,
      recurrence_type: frequency,
      recurrence_day: firstDay,
      second_recurrence_day: secondDay,
    })

    setIsOpen(false)
  }

  const handleOpen = () => {
    setIsOpen(true)
    onEvent(ANALYTICS_EVENTS.RECURRING_TRANSACTIONS_DETAILS_CLICK_PAYMENT_SCHEDULE)
  }

  return (
    <>
      <DataRow
        iconName="sync"
        label={copy.activity_schedule}
        onClick={handleOpen}
        showChevron={false}
        value={`${getFrequencyLabel(copy, repeatingTransaction, true)}`}
      />
      <Drawer
        ariaLabelClose={copy.close_drawer_aria}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onPrimaryAction={handleSave}
        title={copy.payment_schedule}
      >
        <PaymentSchedule
          firstDay={firstDay}
          frequency={frequency}
          onFirstDayChange={setFirstDay}
          onFrequencyChange={setFrequency}
          onSecondDayChange={setSecondDay}
          secondDay={secondDay}
        />
      </Drawer>
    </>
  )
})
